<template>
  <account-modal class="referral-code-send-email">
    <template slot="heading">Send email to:</template>
    <error-alert :error="error" />

    <template slot="content">
      <v-layout
        class="row--data mt-2"
        row
      >
        <v-flex xs6>
          <v-subheader class="v-subheader--dense">Email</v-subheader>
        </v-flex>

        <v-flex xs6>
          <v-text-field
            v-model="form.email"
            class="t-referral-email-field"
            :error-messages="getValidationErrorMessage('email')"
          />
        </v-flex>
      </v-layout>

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onSaveButtonClick"
      >send</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ReferralApi from '@/services/Api/ReferralApi'

  // Events
  import { EVENT_REFERRAL_EMAIL_SENT } from '@/events/referrals'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import form from '@/mixins/form'

  export default {
    name: 'SendEmailToReferralModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: {
          email: null
        },
        sendEmailApiRequest: new ApiRequest(ReferralApi.sendEmail)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      loading () {
        return this.sendEmailApiRequest.loading
      },
      error () {
        return this.sendEmailApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.sendEmailApiRequest
          .execute({
            email: this.parsedFormInput.email
          })
          .then(this.emailSentSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      emailSentSuccessHandler () {
        this.$eventHub.$emit(EVENT_REFERRAL_EMAIL_SENT)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: {
              message: 'Email has been successfully sent.'
            }
          })
        }, 100)
      }
    }
  }
</script>
